var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-mass"},[_c('edit',{attrs:{"title":"Mass Email","api":"notifications/mass","fs":_vm.notificationMassFields},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }